/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2018 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';
import Airglow from 'airglow';
import ReduxStore from '@airglow/store-redux';

import UnifiedContainer from './containers/unified.container';
import bootstrapConfig from './data/bootstrap.config';

const App = ({ plugins }) => (
  <Airglow
    plugins={plugins}
    store={ReduxStore}
    bootstrap={bootstrapConfig}
  >
    <UnifiedContainer />
  </Airglow>
);

export default App;
